import { render, staticRenderFns } from "./PageGuides.vue?vue&type=template&id=a6b8a06c&"
import script from "./PageGuides.vue?vue&type=script&lang=js&"
export * from "./PageGuides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6b8a06c')) {
      api.createRecord('a6b8a06c', component.options)
    } else {
      api.reload('a6b8a06c', component.options)
    }
    module.hot.accept("./PageGuides.vue?vue&type=template&id=a6b8a06c&", function () {
      api.rerender('a6b8a06c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/guides/PageGuides.vue"
export default component.exports